import React from 'react';

function FullPageLayout({ children, marginTop, minHeight, position, top }) {
  return (
    <div
      style={{
        ...{
          left: 0,
          width: '100%',

          backgroundColor: 'var(--dark)'
        },
        ...(position ? { position: position } : { position: 'relative' }),
        ...(minHeight ? { minHeight: minHeight } : { minHeight: '100vh' }),
        ...(marginTop ? { marginTop: marginTop } : {}),
        ...(top ? { top: top } : {})
      }}
    >
      {children}
    </div>
  );
}

export default FullPageLayout;
